import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  FaUserShield,
  FaFileInvoice,
  FaEdit,
  FaChevronRight,
  FaCalendarAlt,
  FaFileExport,
  FaSearch,
} from "react-icons/fa";

const apiBase = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? "http://localhost:3006"
  : "https://api.trubetx.com";

const ProfileSection = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [editingField, setEditingField] = useState(null);

  const [profile, setProfile] = useState({
    real_name: "royalking1",
    email: "royalking1@gmail.com",
    username: "royalking1",
    phone_no: "",
    address: "",
    password: "",
    role: "",
  });

  let token = localStorage.getItem("token");

  async function fetchProfileDetails() {
    try {
      const response = await axios.get(
        `${apiBase}/admin/getMineProfile`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add Authorization header
          },
        }
      );

      if (response?.data?.data) {
        console.log(response.data.data);
        setProfile(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      if (error.response?.status === 401) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        window.location.href = "/login";
      }
    }
  }

  useEffect(() => {
    fetchProfileDetails();
  }, []);

  const handleSave = async () => {
    try {
      const res = await fetch(
        `${apiBase}/admin/updateAdminTypeMineProfile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            token,
            real_name: profile.real_name,
            email: profile.email,
            username: profile.username,
            phone_no: profile.phone_no,
            address: profile.address,
            password: profile.password,
            password2: profile.password,
          }),
        }
      );

      if (res.status === 401) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        window.location.href = "/login";
        return;
      }

      const result = await res.json();

      if (result.status) {
        alert("Profile updated successfully");
        setEditingField(null);
        setProfile((prev) => ({ ...prev, password: "" })); // Clear password after save
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Failed to update profile:", error);
      alert("An error occurred.");
    }
  };

  return (
    <main className="flex lg:ml-[220px] overflow-auto bg-stone-100 pb-8 min-h-screen">
      <div className="w-full flex-1 px-4 sm:px-5">
        {/* Header Section */}
        <div className="my-5">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div className="w-auto mb-3 sm:mb-0">
              <h1 className="text-lg font-bold text-stone-800 md:text-xl">
                My Profile
              </h1>
            </div>
            <div className="w-auto"></div>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <span className="font-semibold text-gray-500">
              {activeTab === "profile" ? "Profile" : "Account Statement"}
            </span>
          </div>
        </div>

        {/* Main Content */}
        <div>
          <div className=" mt-6 w-full min-w-[14rem] overflow-auto">
            <div className="mantine-Tabs-root">
              {/* Tabs Navigation */}
              <div className="">
                <div
                  className="flex flex-wrap justify-start divide-x rounded-t-lg bg-white"
                  role="tablist"
                >
                  <button
                    className={`flex-1 py-3 ${
                      activeTab === "profile"
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-500"
                    }`}
                    onClick={() => setActiveTab("profile")}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <FaUserShield />
                      <span>Profile</span>
                    </div>
                  </button>
                </div>
                {/* Profile Tab Content */}
                {activeTab === "profile" && (
                  <div role="tabpanel" className="bg-neutral-200 rounded-b-lg">
                    <div className="pt-5">
                      <div className="grid gap-3 px-2 sm:px-4 py-4">
                        <div className="overflow-auto rounded-lg bg-white px-2 py-4">
                          <div className="flex flex-wrap border border-b-0 rounded-lg">
                            {/* Name Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Name
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "name" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      {profile.real_name}
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() => setEditingField("name")}
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="text"
                                      value={profile.real_name}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          real_name: e.target.value,
                                        })
                                      }
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={handleSave} // ✅ Save profile to backend
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)} // ❌ Cancel without saving
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Email Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Email
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "email" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      {profile.email}
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() => setEditingField("email")}
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="email"
                                      value={profile.email}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          email: e.target.value,
                                        })
                                      }
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={handleSave} // ✅ Call handleSave
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* username Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                username
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "username" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      {profile.username}
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() =>
                                        setEditingField("username")
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="text"
                                      value={profile.username}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          username: e.target.value,
                                        })
                                      }
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={handleSave} // ✅ Call handleSave
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Role Field */}
                            {/* Role Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Role
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                <div>{profile.role || "N/A"}</div>
                              </div>
                            </div>

                            {/* Phone Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Phone
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "phone" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      {profile.phone_no || "N/A"}
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() => setEditingField("phone")}
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="tel"
                                      value={profile.phone_no}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          phone_no: e.target.value,
                                        })
                                      }
                                      placeholder="Enter phone number"
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={handleSave}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Address Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Address
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "address" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      {profile.address || "N/A"}
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() => setEditingField("address")}
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="text"
                                      placeholder="Enter address"
                                      value={profile.address}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          address: e.target.value,
                                        })
                                      }
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={() => {
                                          handleSave(); // Save profile
                                          setEditingField(null); // Exit edit mode
                                        }}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Password Field */}
                            <div className="flex items-center w-full sm:w-1/2 border-b p-3 sm:p-5">
                              <h3 className="w-24 sm:w-32 py-2 font-bold">
                                Password
                              </h3>
                              <div className="h-full w-px bg-gray-200 mx-2 sm:mx-4"></div>
                              <div className="flex-1">
                                {editingField !== "password" ? (
                                  <div className="flex justify-between items-center">
                                    <div className="text-gray-500">
                                      **********
                                    </div>
                                    <FaEdit
                                      className="h-4 w-4 cursor-pointer text-blue-500 ml-2"
                                      onClick={() =>
                                        setEditingField("password")
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <input
                                      type="password"
                                      value={profile.password}
                                      onChange={(e) =>
                                        setProfile({
                                          ...profile,
                                          password: e.target.value,
                                        })
                                      }
                                      placeholder="Enter new password"
                                      className="border rounded px-2 py-1 flex-1 w-full"
                                    />
                                    <div className="flex gap-2 mt-2 sm:mt-0">
                                      <button
                                        className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                                        onClick={handleSave}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="bg-gray-300 px-3 py-1 rounded text-sm"
                                        onClick={() => setEditingField(null)}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                \
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProfileSection;
